import { styled, Button, Grid, IconButton } from '@mui/material';

export const ButtonsGrid = styled(Grid)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const VehicleButton = styled(Button)(() => ({
  display: 'flex',
  flex: 1,
  flexGrow: 1,
  height: 120,
  backgroundColor: 'white',
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  padding: '0px',
  borderRadius: '15px',
  overflow: 'hidden',
  marginRight: '5px',
}));

export const DeleteButton = styled(IconButton)(() => ({
  display: 'flex',
  padding: 2,
  flexShrink: 0,
}));

export const StyledModalWrapper = styled('div')(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledInputWrapper = styled('div')(() => ({
  width: '60%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledButtonsWrapper = styled('div')(() => ({
  marginTop: 20,
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
